module.exports = __webpack_public_path__ + "static/media/damage-purple-svg.8ff1a8df.svg";